import { ComponentProps } from 'react';
import { DatePickerField } from '@electricjs/arc';

import getDateFnsLocale from '@/helpers/getDateFnsLocale';

/**
 * Wraps Arc's DatePickerField and defaults `locale` to the app's current
 * locale, so every date picker is localized without each caller having to
 * remember to pass `locale={getDateFnsLocale()}`.
 */
export const DateField = ({
  locale = getDateFnsLocale(),
  ...props
}: ComponentProps<typeof DatePickerField>) => (
  <DatePickerField locale={locale} {...props} />
);
